import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from 'containers/Pages/Messages/Modules/dataGridTable';
import { getTimezone } from 'reducers/utils';
import transformMessagingList from 'utils/DataTransform/Messaging/MessagingList';
import { selectors as filtersSelectors } from 'containers/Pages/Messages/Modules/filters';
import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { transformMessagingDetails } from 'utils/DataTransform/Messaging/MessagingDetails';
import { getUserId } from 'reducers/users';

export const getMessageListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getTimezone,
  (list, timezone) => {
    if (!list) return [];
    return transformMessagingList(list, timezone);
  },
);
export const getMessageListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  list => {
    if (!list) return [];
    return list;
  },
);
export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

export const getFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getMessageDetailsRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details) return {};
    return details;
  },
);
export const getMessageDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  details => {
    if (!details) return {};
    return transformMessagingDetails(details);
  },
);
export const replyEnabled = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getUserId,
  (details, userId) => {
    if (!details) return false; //nothing to display
    if (details.senderId === null || details.senderId === '') {
      // it is a system message
      return false;
    } else if (details.recipientId === userId) {
      return true;
    }
    return false;
  },
);
